import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import { VersionFooter } from './VersionFooter';
import HomeIcon from '@material-ui/icons/Home';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import BuildIcon from '@material-ui/icons/Build';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import TimelineIcon from '@material-ui/icons/Timeline';
import DnsIcon from '@material-ui/icons/Dns';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import BugReportIcon from '@material-ui/icons/BugReport';

import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';

// /argocd and /argo-workflows are read-only in-Backstage pages backed by
// the same proxies the entity tabs use (single shared SA, no mutation API).
// The list rows deep-link out to the real Argo UIs for sync/submit/retry,
// where OneLogin SSO + Argo RBAC enforce per-user permissions.

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            <SidebarItem icon={HomeIcon} to="/" text="Home" />
            {nav.take('page:catalog')}
            <SidebarItem icon={LibraryBooksIcon} to="/docs" text="Docs" />
            {nav.take('page:scaffolder')}
            <SidebarDivider />
            <SidebarItem icon={NewReleasesIcon} to="/releases" text="Releases" />
            <SidebarItem icon={BuildIcon} to="/devops" text="DevOps" />
            <SidebarItem icon={BugReportIcon} to="/qa" text="QA" />
            <SidebarItem icon={TimelineIcon} to="/changes" text="Changes" />
            <SidebarItem icon={DnsIcon} to="/environments" text="Environments" />
            <SidebarItem icon={AccountTreeIcon} to="/knowledge-graph" text="Architecture" />
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
          <VersionFooter />
        </Sidebar>
      );
    },
  },
});
